export default {
  searchStatusEnum: {
    notSearched: 0,
    searching: 1,
    searchCompleted: 2,
  },
  actionTypes: {
    loadSearchPage: 'LOAD_SEARCH_PAGE',
    getSearchResults: 'GET_SEARCH_RESULTS',
  },
  mutationTypes: {
    clearSearchResults: 'CLEAR_SEARCH_RESULTS',
    executeSearch: 'EXECUTE_SEARCH',
    searchFinished: 'SEARCH_FINISHED',
  },
};
